/**
 * Format a session datetime for UI clock labels in IST.
 *
 * - Aware ISO (Z / ±offset): convert absolute instant → Asia/Kolkata.
 * - Naive ISO (no zone): backend already stores IST wall clock — do not
 *   parse as browser-local then re-zone (that shifts e.g. 1:33 PM → 4:03 AM).
 */

function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

function to12h(hours24: number, minutes: number): string {
  const ampm = hours24 >= 12 ? "PM" : "AM";
  const h12 = hours24 % 12 || 12;
  return `${h12}:${pad2(minutes)} ${ampm}`;
}

export function formatIstClock(raw: unknown): string {
  if (raw == null) return "";
  const s = String(raw).trim();
  if (!s) return "";

  if (s.includes("T")) {
    const hasZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(s);
    if (hasZone) {
      const d = new Date(s);
      if (!Number.isNaN(d.getTime())) {
        return d.toLocaleTimeString("en-US", {
          timeZone: "Asia/Kolkata",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
      }
    }

    const m = s.match(/T(\d{1,2}):(\d{2})/);
    if (m) {
      return to12h(Number(m[1]), Number(m[2]));
    }
  }

  return s;
}
